import styled from "styled-components";
import React from "react";

const TitleStyled = styled.div`
    font-family: Arial,Helvetica Neue,Helvetica,sans-serif;
    text-align: center;
    img{
      max-width: 100px;
    }
    h1{
        margin-bottom: 0;
        text-align: center;
    }
    h3{
            font-size: 14px;
            text-align: center;
    color: #c3c3c3;
    font-weight: normal;
    }
`;

const Title = (props: any) => {
    return (
        <TitleStyled>
            <h1>{props.data.title !== '' ? props.data.title : 'Lorem Ipsum is simply'}</h1>
            <h3>{props.data.subTitle !== '' ? props.data.subTitle : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry'}</h3>
        </TitleStyled>
    );
};

export default Title;
